﻿const name = 'baixaTituloAutomatica'
const templateUrl = new URL('./template.html', import.meta.url).href;
const controller = () => import('./controller')

export default {
    name,
    templateUrl,
    controller
}
